var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"primary"},[_c('v-scale-transition',{attrs:{"group":""}},[_c('router-view',{key:"empty-router"})],1)],1),_c('Kn-mini-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }